import React from 'react';
import './BusinessCard.css';

function BusinessCard({ business, onViewDetails }) {
  if (!business) return null;

  return (
    <div className="business-card">
      <div className="business-header">
        <h3>{business.name}</h3>
        <span className="business-category">{business.category || business.type}</span>
      </div>
      
      {business.address && (
        <div className="business-address">
          <span className="icon">📍</span>
          {business.address}
        </div>
      )}
      
      {business.phone && (
        <div className="business-phone">
          <span className="icon">📞</span>
          {business.phone}
        </div>
      )}
      
      {business.hours && (
        <div className="business-hours">
          <span className="icon">🕒</span>
          {formatTodaysHours(business.hours)}
        </div>
      )}
      
      {business.rating && (
        <div className="business-rating">
          <span className="rating-stars">
            {'★'.repeat(Math.floor(business.rating))}{business.rating % 1 !== 0 ? '½' : ''}{'☆'.repeat(5 - Math.ceil(business.rating))}
          </span>
          <span className="rating-value">({business.rating}/5)</span>
        </div>
      )}
      
      <button 
        className="view-details-btn"
        onClick={() => onViewDetails(business)}
      >
        View Details
      </button>
    </div>
  );
}

function formatTodaysHours(hours) {
  const today = new Date().toLocaleDateString('en-US', { weekday: 'long' }).toLowerCase();
  return hours[today] || 'Hours not available';
}

export default BusinessCard;